module.exports = __webpack_public_path__ + "static/media/official.b837de2.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/australia_a_league/official.mp4
// module id = gtzr
// module chunks = 1